import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PlayerServiceBookingCalendar from '../components/player-service-booking-calendar';
import {push} from 'connected-react-router';
import queryString from 'querystring';
import {addToBookingQueue, filterBookingFieldId, bookingSlotSelected, bookingMultiSlotsSelected, showBookingServiceSlotModal, hideBookingServiceSlotModal, newBooking, saveServiceBooking, bookingSelected, purchaseVideo, acceptPrivacy, getSlots, getVideosStore, getVideosStorePartnerVideo, deleteServiceBooking, startBookingTopUp, restoreBookingTopupContext} from '../actions/player';
import {showMessage} from '../actions/messages';
import {getBookingTopupResume} from '../util/booking-topup-resume';

const mapStateToProps = ({player: {filterBookableFields, selectedPartner, selectedPartnerServices, slots, isBookingServiceSlotModalVisible, bookingSlot, bookingSlots, bookingFieldId, bookings, booking, affiliations}, login: {token, profile}}, ownProps) => ({
  isLogged: token !== null,
  selectedPartner,
  selectedPartnerServices,
  slots,
  isBookingServiceSlotModalVisible,
  bookingSlot,
  bookingSlots,
  bookingFieldId,
  bookings,
  booking,
  profile,
  filterBookableFields,
  affiliations,
  resumeSlotId: new URLSearchParams(ownProps.location.search).get('resumeSlotId')
});

const mapDispatchToProps = dispatch => ({
  bookingSlotSelected: ev => {
    if (new Date(ev.slot.startDatetime) < Date.now()) {
      dispatch(showMessage('BOOKINGS', 'BOOKING_EVENT_HAS_PASSED'));
    } else if (ev.slot.state === 'reserved') {
      dispatch(showMessage('BOOKINGS', 'BOOKING_EVENT_RESERVED'));
    }
      else if (ev.slot.state === "unavailable") {
      dispatch(showMessage('BOOKINGS', 'BOOKING_EVENT_UNAVAILABLE'));
    } else if (ev.slot.bookingId && ev.booking) {
      dispatch(bookingSlotSelected(ev.slot));
      dispatch(bookingSelected(ev.booking));
      dispatch(showBookingServiceSlotModal());
    } else {
      const topupResume = getBookingTopupResume();
      const resumedDraft = topupResume && topupResume.resourceType === 'service' && String(topupResume.slotId) === String(ev.slot.slotId)
        ? topupResume.bookingDraft
        : null;
      dispatch(bookingSlotSelected(ev.slot));
      dispatch(newBooking(resumedDraft || {description: null, payment: false, playersNumber: 1, otherPlayers: [''], slots: [ev.slot.slotId], rtvOrAcademy: false, invitedPlayers: [], invitedGuests: []}));
      dispatch(showBookingServiceSlotModal());
    }
  },
  bookingMultiSlots: slots => {
    dispatch(bookingMultiSlotsSelected(slots));
    dispatch(newBooking({description: null, payment: false, playersNumber: 1, otherPlayers: [''], slots: slots.map(s => s.slotId), rtvOrAcademy: false, invitedPlayers: [], invitedGuests: []}));
    dispatch(showBookingServiceSlotModal());
  },
  addToBookingQueue: slotId => {
    dispatch(addToBookingQueue(slotId));
  },
  hideBookingSlotModal: () => {
    dispatch(hideBookingServiceSlotModal());
  },
  saveBooking: booking => dispatch(saveServiceBooking(booking)),
  requestDelete: phoneNumber => {
    dispatch(showMessage('BOOKINGS', 'BOOKING_HOW_CANCEL', {phoneNumber}));
  },
  purchaseVideo: slots => {
    dispatch(purchaseVideo(slots));
  },
  showMessage: (title, body) => {
    dispatch(showMessage(title, body));
  },
  acceptPrivacy: () => {
    dispatch(acceptPrivacy());
  },
  getSlotsByWeek: (partnerId, serviceId) => targetDate => {
    return dispatch(getSlots(partnerId, serviceId, targetDate, 'service'));
  },
  showVideoStore: (partnerUid, serviceId, fromDatetime, toDatetime) => {
    dispatch(getVideosStore(partnerUid, null, serviceId, fromDatetime, toDatetime));
    dispatch(getVideosStorePartnerVideo(partnerUid));
    const params = Object.fromEntries(Object.entries({serviceId, fromDatetime, toDatetime}).filter(([_, v]) => v !== null));

    dispatch(push(`/player-video-store-partner?${queryString.stringify(params)}`));
  },
  showCalendar: (partnerId, serviceId = null) => () => {
    dispatch(filterBookingFieldId(serviceId));
    dispatch(getSlots(partnerId, serviceId, new Date(), 'service'));
    dispatch(push('player-service-booking-calendar'));
  },
  deleteBooking: (bookingId, partnerId, multiBooking) => {
    dispatch(deleteServiceBooking(bookingId, partnerId, multiBooking));
  },
  startBookingTopUp: (amount, slotId, bookingDraft = null, recoveryContext = {}) => dispatch(startBookingTopUp(amount, slotId, bookingDraft, recoveryContext)),
  restoreBookingTopupContext: () => dispatch(restoreBookingTopupContext('service'))
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerServiceBookingCalendar));
